module.exports = __webpack_public_path__ + "740e15989ec648b59d147c1e1b3796d9.png";